/**
 * 扩展对象的属性
 */

function extend() {
    let target = arguments[0] || {}
    for (let i = 1; i < arguments.length; i++) {
        let obj = arguments[i]
        if (obj) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    target[key] = obj[key]
                }
            }
        }
    }
    return target
}

export default extend